import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { useAdminAuth } from '../Provider/AdminAuthProvider';
import AdminLogin from '../pages/AdminLogin';
import { EmployerVerification } from '../pages/EmployerVerification';
import AdminDashboard from '../pages/AdminDashboard';
import AdminSettings from '../pages/AdminSettings';

const ProtectedAdminRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-orange-500"></div>
      </div>
    );
  }

  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

const AdminRouting = () => {
  return (
    <Routes>
      {/* Admin Login Route */}
      <Route path="/login" element={<AdminLogin />} />
      
      {/* Protected Admin Routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedAdminRoute>
            <AdminDashboard />
          </ProtectedAdminRoute>
        } 
      />
      
      <Route 
        path="/verification" 
        element={
          <ProtectedAdminRoute>
            <EmployerVerification />
          </ProtectedAdminRoute>
        } 
      />
      
      <Route 
        path="/settings" 
        element={
          <ProtectedAdminRoute>
            <AdminSettings />
          </ProtectedAdminRoute>
        } 
      />
      
      {/* Default redirect */}
      <Route 
        path="/" 
        element={
          <ProtectedAdminRoute>
            <Navigate to="/verification" replace />
          </ProtectedAdminRoute>
        } 
      />
      
      {/* Catch all - redirect to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AdminRouting;